export default "__VITE_ASSET__2NmjjL8l__"